<template>
  <CollapsibleSection
    :header-label="$t('identificationInformation')"
    body-class="w-full flex flex-col gap-y-3"
    disabled
  >
    <Form
      :initial-values="initialValues"
      v-slot="{ values, setFieldValue }"
      class="flex flex-col gap-y-3"
      @submit="(values) => onSubmit(values)"
    >
      <InfoBar>
        <div class="flex flex-col gap-y-1.5 text-white text-justify text-base">
          <p v-if="values.isPassportSelected === 1">
            {{ $t('pasportVisaNote') }}
          </p>
          <p>
            {{ $t('onArrivalVisaNoteGuest') }}
          </p>
        </div>
      </InfoBar>

      <Field name="isPassportSelected" v-slot="{ field, errors: errs, handleChange }">
        <RadioGroup
          :field="field"
          :errors="errs"
          :label="$t('chooseIdentifier')"
          :radio-options="identifierOptions"
          :default-value="initialValues[field.name]"
          @on-change="(option) => handleChange(option.value)"
        ></RadioGroup>
      </Field>
      <component :is="buildComponent(values.isPassportSelected)" />
      <GRecaptcha
        ref="gRecaptchaRef"
        class="flex justify-center"
        @successCallback="(args) => setFieldValue('recaptchaResponse', args)"
      ></GRecaptcha>
      <div class="flex justify-end">
        <button
          class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        >
          <div class="p-2 bg-primary rounded-s-md">
            <faMagnifyingGlass class="w-4 fill-white"></faMagnifyingGlass>
          </div>
          <span class="w-full text-center">
            {{ $t('Search') }}
          </span>
          <div class="p-0.5"></div>
        </button>
      </div>
    </Form>
  </CollapsibleSection>
</template>

<script setup>
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import InfoBar from '@/components/Form/InfoBar.vue'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import RadioGroup from '@/components/SimpleForm/RadioGroup.vue'
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import { useCurrentVisaStore } from '@/stores/current_visa.js'
import FilenumberForm from '@/views/services/public-visa/CurrentVisaForm/_FilenumberForm.vue'
import PassportForm from '@/views/services/public-visa/CurrentVisaForm/_PassportForm.vue'
import UnifiedForm from '@/views/services/public-visa/CurrentVisaForm/_UnifiedForm.vue'
import { notify } from 'notiwind'
import { Field, Form } from 'vee-validate'
import { defineEmits, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits('onSubmit')

const initialValues = {
  isPassportSelected: 1,
  // passportNumber: 'P7670197A',
  // passportTypeId: 1,
  // dateOfBirth: '1990-07-03',
  // currentNationalityId: 40
}

const identifierOptions = [
  { value: 1, label: 'PassportInformation' },
  { value: 2, label: 'fileVisaNumber' },
  { value: 3, label: 'unifiedNumber' }
]

const i18n = useI18n()
const currentVisaStore = useCurrentVisaStore()

onMounted(async () => {
  await currentVisaStore.fetchLookups()
})

function buildComponent(selectedId) {
  if (selectedId === 1) {
    return PassportForm
  }
  if (selectedId === 2) {
    return FilenumberForm
  }
  if (selectedId === 3) {
    return UnifiedForm
  }
}

async function onSubmit(form) {
  if (!form.recaptchaResponse) {
    notify(
      {
        group: 'error',
        title: i18n.t('captchaNotProcessed')
      },
      -1
    )
    return
  }

  emit('onSubmit', form)
}
</script>

<style lang="scss" scoped></style>
